import PropTypes from 'prop-types';
import React from 'react';

import LocalizacaoMotorista from './LocalizacaoMotorista';
import { ModalPlaca } from './styles';

export default function Localizacao({
  dataLocalizacao,
  modalLocalizacaoVisible,
  setModalLocalizacaoVisible,
}) {
  const closeModal = () => {
    setModalLocalizacaoVisible(false);
  };

  return (
    <>
      <ModalPlaca
        title={`Onde está o motorista: ${dataLocalizacao.placa}?`}
        visible={modalLocalizacaoVisible}
        cancelButtonProps={{ style: { display: 'none' } }}
        okText="Ok, entendi"
        onOk={closeModal}
        onCancel={closeModal}
      >
        <LocalizacaoMotorista dataLocalizacao={dataLocalizacao} />
      </ModalPlaca>
    </>
  );
}

Localizacao.propTypes = {
  dataLocalizacao: PropTypes.objectOf(PropTypes.string).isRequired,
  modalLocalizacaoVisible: PropTypes.bool.isRequired,
  setModalLocalizacaoVisible: PropTypes.func.isRequired,
};
